import { render } from "./pantallacocina.vue?vue&type=template&id=0018b58e&scoped=true"
import script from "./pantallacocina.vue?vue&type=script&lang=js"
export * from "./pantallacocina.vue?vue&type=script&lang=js"

import "./pantallacocina.vue?vue&type=style&index=0&id=0018b58e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0018b58e"]])

export default __exports__